import React from 'react'
import Content from './Content'
import Header from './Header';
import Footer from './Footer';
import { Menu, MenuItem, MenuButton, SubMenu, MenuDivider } from '@szhsin/react-menu';
import Icon from "components/Icon";
import { Link, useHistory } from 'react-router-dom'
import { useEffect } from 'react';
import { connect } from 'react-redux'
import { getUser } from 'redux/actions/User'
import { isLoggedIn, logout } from "utils";
import { mapRole } from "constants/Common";
function Layout(props: any) {
  const history = useHistory()
  useEffect(() => {
    if (isLoggedIn()) {
      props.getUser()
    }
  }, [])

  const onLogoClick = () => { history.push("/") }

  return (
    <div>
      <header>
        <Header onLogoClick={onLogoClick} >
          {isLoggedIn() ?
          <>
            <button onClick={onLogoClick} className="btn btn-primary margin-right-4">
              Home
            </button>
            <Menu menuButton={<MenuButton className="btn  btn-primary"><div>{props.user?.first_name + " " + props.user?.last_name} <Icon name="angle-down" /> </div></MenuButton>}>
              <MenuItem onClick={() => history.push("/profile")}> <Icon name="user m-2" />  Profile</MenuItem>
              <MenuDivider />
              <MenuItem onClick={logout}> <Icon name="sign-out m-2" />  Logout</MenuItem>
            </Menu>
            
            </> :
            <a href="https://www.asiapropertyawards.com/en/">Visit PropertyGuru Asia Property Awards website</a>

            }
        </Header>
      </header>
      <main>
        <Content role={props.user?.role} />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  )
}


const mapDispatchToProps = {
  getUser
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.user,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Layout);